import React from 'preact/compat';
import translator from 'Flyout/Api/Translator';

export default class SearchBar extends React.Component {
    constructor() {
        super();

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.clear = this.clear.bind(this);
    }

    handleTextChange(e) {
        this.props.onSearchTextChange(e.target.value);
    }

    handleKeyPress(event) {
        // clears search field if escape key is pressed
        if (event.key === 'Escape') {
            this.clear();
            event.stopPropagation();
        }
    }

    clear() {
        this.searchField.value = '';
        this.props.onSearchTextChange('');
    }

    render() {
        return (
            <form className="flyout-search-form" onReset={this.clear}>
                <label htmlFor="flyout-search-input" className="show-for-sr visually-hidden">
                    { translator.i18n('Search in faculties and institutions') }
                </label>
                <input
                    id="flyout-search-input"
                    name="filter"
                    type="text"
                    required
                    placeholder={`${translator.i18n('Search in faculties and institutions')}...`}
                    ref={(elem) => { this.searchField = elem; }}
                    className="input-group-field input-search form-control"
                    onChange={this.handleTextChange}
                    onKeyDown={this.handleKeyPress}
                />
                <div className="icon-close" />
                <input type="reset" className="btn-link" value={translator.i18n('Reset')} />
            </form>
        );
    }
}
